/**************************************************************************************************/
/*   File: /src/app/shared/models/dossier.content.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Mar 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocumentId } from './local.document.id';
import { SpatialDataTypeEnum } from '../enums/spatial.data.type.enum';


/**
 * The dossier content
 */
export class DossierContent {
    /**
     * The plan code
     */
    planCode: string;
    /**
     * The is spatial dossier
     */
    regulationsDossier = false;
    /**
     * The is regulations dossier
     */
    spatialDossier = false;
    /**
     * The ambito code
     */
    territorialAreasCodes = [];
    /**
     * The spatial data type
     */
    defaultSpatialDataType: SpatialDataTypeEnum;
}